import { jsx as _jsx } from "react/jsx-runtime";
import { FHIRQueryRequestHistory } from './FHIRQueryRequestHistory/index.js';
import { FHIRQueryRequestComposer } from './FHIRQueryRequestComposer/index.js';
import { Page_BaseSandbox } from '../Page_BaseSandbox/Page_BaseSandbox.js';
import { workspaceKey_AdvisorSandboxEpic } from '../../workspace-configs.js';
import { TS_HorizontalWorkspace } from '@nu-art/ts-workspace-frontend/index';
import { FHIRQueryRequestTemplates } from './FHIRQueryRequestTemplates/index.js';
const EditorKey_SandboxOrderFHIRQuery = 'sandbox-advisor-FHIR-query';
export class Page_SandboxFHIRQuery extends Page_BaseSandbox {
    static Route = {
        key: 'FHIR-query',
        path: 'FHIR-query',
        Component: this,
    };
    workspace = () => ({
        id: EditorKey_SandboxOrderFHIRQuery,
        key: workspaceKey_AdvisorSandboxEpic,
        instances: {},
        renderers: {
            horizontalSpace: TS_HorizontalWorkspace,
            templates: () => _jsx(FHIRQueryRequestTemplates, {}),
            composer: () => _jsx(FHIRQueryRequestComposer, {}),
            history: () => _jsx(FHIRQueryRequestHistory, {})
        }
    });
    getHeader() {
        return 'FHIR Query';
    }
}
//# sourceMappingURL=Page_SandboxFHIRQuery.js.map